import { TagModel } from "@app/shared/services/gtm/model/tag.model";
import { ProductECommerceModel } from "@app/shared/services/gtm/model/product-ecommerce.model";

export class ProductTagModel extends TagModel {
  ecommFunnelType: string;
  ecommerce: ProductECommerceModel;
}
